import { useSearchParams } from "react-router-dom";

export function useAdminListQuery() {
  const [searchParams, setSearchParams] = useSearchParams();
  const query = Object.fromEntries(searchParams.entries());
  function update(patch, { resetOffset = true } = {}) {
    setSearchParams((current) => {
      const next = new URLSearchParams(current);
      for (const [key, value] of Object.entries(patch)) {
        if (value === undefined || value === "" || value === "all") next.delete(key);
        else next.set(key, String(value));
      }
      if (resetOffset && Object.keys(patch).some((key) => key !== "offset")) next.delete("offset");
      return next;
    });
  }
  function reset() { setSearchParams(new URLSearchParams()); }
  return { query, update, reset };
}

